var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup691314505(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6418C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6877C12 12.3429 13.0014 11.2085 14.3359 11.0417L16.584 10.7607C16.9819 10.7109 17.3333 11.0212 17.3333 11.4222V15.4356C17.3333 15.7615 17.0977 16.0396 16.7763 16.0932L14.387 16.4914C13.7017 16.6056 13.0692 16.9311 12.578 17.4223L12 18.0003V13.6877Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6877C12 12.3429 10.9986 11.2085 9.66409 11.0417L7.41602 10.7607C7.01812 10.7109 6.66667 11.0212 6.66667 11.4222V15.4356C6.66667 15.7615 6.90228 16.0396 7.22373 16.0932L9.61298 16.4914C10.2983 16.6056 10.9308 16.9311 11.422 17.4223L12 18.0003V13.6877Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 10.667C14.2782 9.5018 13.2308 8.66699 11.9997 8.66699C10.7685 8.66699 9.72117 9.5018 9.33301 10.667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 7.33333C10.667 6.59695 11.2639 6 12.0003 6V6C12.7367 6 13.3337 6.59695 13.3337 7.33333V7.33333C13.3337 8.06971 12.7367 8.66667 12.0003 8.66667V8.66667C11.2639 8.66667 10.667 8.06971 10.667 7.33333V7.33333Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup691314505);
export default __webpack_public_path__ + "static/media/Group 691314505.8cfde0e33503b8c58cfd3b9f21a3a83d.svg";
export { ForwardRef as ReactComponent };